import script from "./HeaderTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderTip.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderTip.vue?vue&type=style&index=0&id=6da1f440&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da1f440"]])

export default __exports__